import { Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0A192F] text-white bg-grid-dark" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="inline-flex items-center gap-3 bg-white p-3 pr-5">
            <img
              src="https://customer-assets.emergentagent.com/job_small-biz-tax-hub/artifacts/gg58om9x_NXTAXLOGOW.2022.png"
              alt="NZ Taxation Limited"
              className="h-12 w-12 object-contain"
            />
            <div className="leading-tight">
              <div className="font-heading font-black text-[15px] text-[#0A192F]">NZ Taxation</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 font-bold">
                Limited
              </div>
            </div>
          </div>
          <p className="mt-5 text-slate-400 leading-relaxed max-w-xs text-sm">
            A fully remote NZ tax practice — Xero-first accounting for companies, Prosaic
            for sole traders. Registered in Te Atatu, Auckland; serving small business across
            Aotearoa.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-slate-400">Contact</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[#C9A349]" />
              <a
                href="mailto:info@nztaxation.nz"
                className="hover:text-[#C9A349] transition-colors"
                data-testid="footer-email"
              >
                info@nztaxation.nz
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#C9A349] mt-0.5" />
              <div className="leading-tight">
                <div>Fully remote · NZ-wide</div>
                <div className="text-xs text-slate-400 mt-0.5">
                  Registered office: Te Atatu, Auckland
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-slate-400">
            Services
          </div>
          <ul className="mt-4 space-y-2 text-sm text-slate-300">
            <li>Accounting</li>
            <li>Taxation</li>
            <li>Bookkeeping</li>
            <li>Payroll</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-400">
          <div className="flex flex-wrap items-center gap-4">
            <div>© {new Date().getFullYear()} NZ Taxation Limited. All rights reserved.</div>
            <Link
              to="/privacy"
              className="hover:text-[#C9A349] transition-colors uppercase tracking-[0.18em] font-bold"
              data-testid="footer-privacy-link"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="hover:text-[#C9A349] transition-colors uppercase tracking-[0.18em] font-bold"
              data-testid="footer-terms-link"
            >
              Terms
            </Link>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-[#C9A349] rotate-45" />
            <span className="uppercase tracking-[0.22em] font-bold">We love XERO</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
